// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAtkNdM9IxuU3xOgTUOjllvisPJYREJjvE",
    authDomain: "btt-firestore.firebaseapp.com",
    databaseURL: "https://btt-firestore.firebaseio.com",
    projectId: "btt-firestore",
    storageBucket: "",
    messagingSenderId: "375298002497"
  }
};



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/environments/environment.ts